<template>
    <div class="p">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item to="/">Dashboard</el-breadcrumb-item>
            <el-breadcrumb-item>批次 {{ code }}</el-breadcrumb-item>
        </el-breadcrumb>

        <el-card style="margin-top:12px;">
            <div slot="header" class="flex">
                <span>批次操作</span>
            </div>
            <el-form :inline="true" size="small">
                <el-button type="primary" size="mini" disabled>当前批次：{{ code }}</el-button>
                <el-popconfirm title="物理删除该批次？" @confirm="deleteBatch">
                    <el-button slot="reference" type="danger" size="mini" style="margin-left:6px">删除批次</el-button>
                </el-popconfirm>
                
                <el-form-item label="批量重置为">
                    <el-select v-model="resetTarget" placeholder="选择状态">
                        <el-option label="未处理（unprocessed）" value="unprocessed" />
                        <el-option label="已完成（completed）" value="completed" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-popconfirm title="确认批量重置该批次所有账号？" @confirm="resetBatch">
                        <el-button slot="reference" type="warning">批量重置</el-button>
                    </el-popconfirm>
                </el-form-item>
            </el-form>
        </el-card>

        <el-card style="margin-top:12px;">
            <div slot="header" class="flex">
                <span>账号列表</span>
                <div>
                    <el-select v-model="state" placeholder="全部状态" clearable style="width:200px" @change="fetchList(1)">
                        <el-option label="全部" :value="''" />
                        <el-option label="未处理" value="unprocessed" />
                        <el-option label="已占用" value="reserved" />
                        <el-option label="已完成" value="completed" />
                        <el-option label="失败" value="failed" />
                    </el-select>
                    <el-button size="mini" @click="fetchList(1)" icon="el-icon-refresh">刷新</el-button>
                </div>
            </div>

            <el-table :data="list" v-loading="loading" size="small" style="width:100%">
                <el-table-column prop="id" label="ID" width="80" />
                <el-table-column prop="email" label="Email" />
                <el-table-column prop="state" label="状态" width="110" />
                <el-table-column prop="reserved_at" label="占用时间" width="180">
                    <template slot-scope="s">{{ fmt(s.row.reserved_at) }}</template>
                </el-table-column>
                <el-table-column prop="lease_expire_at" label="租约到期" width="180">
                    <template slot-scope="s">{{ fmt(s.row.lease_expire_at) }}</template>
                </el-table-column>
                <el-table-column prop="completed_at" label="完成时间" width="180">
                    <template slot-scope="s">{{ fmt(s.row.completed_at) }}</template>
                </el-table-column>
                <el-table-column prop="failed_at" label="失败时间" width="180">
                    <template slot-scope="s">{{ fmt(s.row.failed_at) }}</template>
                </el-table-column>
                <el-table-column label="操作" width="260" fixed="right">
                    <template slot-scope="s">
                        <el-select v-model="s.row._target" placeholder="目标状态" size="mini" style="width:140px">
                            <el-option label="未处理" value="unprocessed" />
                            <el-option label="已完成" value="completed" />
                            <el-option label="失败" value="failed" />
                        </el-select>
                        <el-button size="mini" type="primary" style="margin-left:6px"
                            @click="resetOne(s.row)">重置</el-button>
                    </template>
                </el-table-column>
            </el-table>

            <div style="text-align:right;margin-top:12px;">
                <el-pagination background layout="prev, pager, next, jumper, ->, total" :page-size="pageSize"
                    :current-page.sync="page" :total="total" @current-change="fetchList">
                </el-pagination>
            </div>
        </el-card>
    </div>
</template>

<script>
import api from '@/api/http'

export default {
    name: 'BatchDetail',
    props: ['code'],
    data() {
        return {
            state: '',
            list: [],
            total: 0,
            page: 1,
            pageSize: 50,
            loading: false,
            resetTarget: ''
        }
    },
    created() {
        this.fetchList(1)
    },
    methods: {
        fmt(iso) { return iso ? new Date(iso).toLocaleString() : '' },
        async fetchList(p) {
            if (p) this.page = p
            this.loading = true
            try {
                const params = { page: this.page, page_size: this.pageSize }
                if (this.state) params.state = this.state
                const { data } = await api.get(`/batches/${encodeURIComponent(this.code)}/accounts`, { params })
                if (data.code === 1) {
                    this.list = (data.data.list || []).map(x => ({ ...x, _target: '' }))
                    this.total = data.data.total || 0
                } else {
                    this.$message.error(data.message || '加载失败')
                }
            } catch (e) {
                this.$message.error('网络错误')
            } finally {
                this.loading = false
            }
        },
        async resetOne(row) {
            if (!row._target) { this.$message.warning('请选择目标状态'); return }
            const payload = { email: row.email, state: row._target, lease_check: false }
            const { data } = await api.post('/accounts/state', payload)
            if (data.code === 1) {
                this.$message.success('已重置')
                this.fetchList(this.page)
            } else {
                this.$message.error(data.message || '重置失败')
            }
        },
        async resetBatch() {
            if (!this.resetTarget) { this.$message.warning('请选择目标状态'); return }
            const { data } = await api.post(`/batches/${encodeURIComponent(this.code)}/reset-state`, { state: this.resetTarget })
            if (data.code === 1) {
                this.$message.success(`批量重置完成（${data.data.affected} 条）`)
                this.fetchList(1)
            } else {
                this.$message.error(data.message || '批量重置失败')
            }
        },
        async deleteBatch() {
            const { data } = await api.delete(`/batches/${encodeURIComponent(this.code)}?force=true`)
            if (data.code === 1) {
                this.$message.success('批次已删除')
                this.$router.replace('/')
            } else {
                this.$message.error(data.message || '删除失败')
            }
        }
    }
}
</script>

<style scoped>
.p {
    padding: 12px;
}

.flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
</style>
